/**
 * @module DualYAxisSetting/useLineDualMetricLinkage
 * @description 折线双轴 · 指标多选分区联动
 */

import { useCallback } from 'react';
import { getMetricDiff } from '../../common/DualAxis/axisMetricUtils';
import type {
  ILineDualAxisConfig,
  TAxisKey,
  TAxisMetric,
} from '../../common/DualAxis/types';

interface IUseLineDualMetricLinkageParams {
  primaryAxis: ILineDualAxisConfig;
  secondaryAxis: ILineDualAxisConfig;
  metricValues: string[];
  getMetricsPayload: (keys: string[]) => TAxisMetric[];
  chartType: string;
  dispatchAxes: (payload: Partial<Record<TAxisKey, ILineDualAxisConfig>>) => void;
}

export function useLineDualMetricLinkage({
  primaryAxis,
  secondaryAxis,
  metricValues,
  getMetricsPayload,
  chartType,
  dispatchAxes,
}: IUseLineDualMetricLinkageParams) {
  return useCallback(
    (axisKey: TAxisKey, selectedKeys: string[]) => {
      const otherKey: TAxisKey =
        axisKey === 'primaryYAxis' ? 'secondYAxis' : 'primaryYAxis';
      const currentAxis =
        axisKey === 'primaryYAxis' ? primaryAxis : secondaryAxis;
      const otherAxis =
        axisKey === 'primaryYAxis' ? secondaryAxis : primaryAxis;
      const restKeys = getMetricDiff(metricValues, selectedKeys);

      dispatchAxes({
        [axisKey]: {
          ...currentAxis,
          metrics: getMetricsPayload(selectedKeys),
          chartType,
        },
        [otherKey]: {
          ...otherAxis,
          metrics: getMetricsPayload(restKeys),
          chartType,
        },
      });
    },
    [
      chartType,
      dispatchAxes,
      getMetricsPayload,
      metricValues,
      primaryAxis,
      secondaryAxis,
    ],
  );
}
